@if (messages.length > 0) {
  <app-top-banner-shell variant="info">
    @for (message of messages; track message.id; let i = $index) {
      @if (i > 0) {
        <div class="top-banner-shell__separator"></div>
      }
      <app-top-banner-row
        [title]="message.title"
        [htmlContent]="message.content"
        (dismiss)="onClose(message)">
      </app-top-banner-row>
    }
  </app-top-banner-shell>
}
